import React from 'react'
import { Select } from 'antd'

const { Option } = Select

class InStockTypeSelect extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Select placeholder='please select in-stock type' {...this.props}>
        <Option value='in-stock'>In Stock</Option>
        <Option value='available-for-licensing'>Available for licensing</Option>
      </Select>
    )
  }
}

export default InStockTypeSelect
